module.exports = __webpack_public_path__ + "img/banner-onde-os-astros.cbb902cc.png";